import {required, helpers} from '@vuelidate/validators';
import {computed} from "vue";

export function getContactUsRules(userStore, t) {
    return computed(() => {
        return {
            last_name: userStore.isOverseasUser ? {} : {
                required: helpers.withMessage(t('ERROR_LAST_NAME_REQUIRED'), required),
            },
            first_name: {
                required: helpers.withMessage(t('ERROR_FIRST_NAME_REQUIRED'), required),
            },
            phone_number: {
                required: helpers.withMessage(t('ERROR_PHONE_NUMBER_REQUIRED'), required),
            },
            email: {
                required: helpers.withMessage(t('ERROR_EMAIL_REQUIRED'), required),
            },
            category_id: {
                required: helpers.withMessage(t('ERROR_CATEGORY_ID_REQUIRED'), required),
            },
            content: {
                required: helpers.withMessage(t('ERROR_CARD_DATE_REQUIRED'), required),
            },
        }
    })
}